import { useMemo } from "react";
import { ShadowMaterial } from "../../materials/ShadowMaterial";

const TreeShadow = ({ size = 1.5, opacity = 0.3, softness = 1.5 }) => {
  const material = useMemo(
    () => new ShadowMaterial(opacity, softness),
    [opacity, softness]
  );

  return (
    <mesh
      rotation={[-Math.PI / 2, 0, 0]}
      position={[0, -0.98, 0]}
      renderOrder={-1}
    >
      <planeGeometry args={[size, size, 64, 64]} />
      <primitive object={material} attach="material" />
    </mesh>
  );
};

export default TreeShadow;
